import React,{useState, useRef, useEffect }  from "react";
import { useDispatch } from "react-redux";
import { userVerifyOTP } from "../store/actions/User";

import ImgLogo from  "./img/koooviblank.gif";
import Loading from "./Loading/Loading";
import {  Link  } from "react-router-dom";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
// import { useHistory } from "react-router-dom/cjs/react-router-dom";
import './loginSignUp.css'
const ValidateOTP = ()=>{
  
const data = useSelector((state)=>state?.user?.user);
   
  const [inputs, setInputs] = useState(['', '', '', '']); // State to hold input values

  const [MyOTPData, setMyOTPData] =  useState({user_email:"",OTP:""})
   const inputRefs = useRef([...Array(4)].map(() => React.createRef())); // Refs for input fields
  const handleChange = (index, value) => {
    const newInputs = [...inputs];
    newInputs[index] = value;
    setInputs(newInputs);

    // If a digit is entered and there's another input field, focus on it
    if (value.length === 1 && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1].current.focus();
    }
  };
  useEffect(() => {
    // Focus the input field when the component mounts
    inputRefs.current[0].current.focus();
    
 

  }, []); // Empty dependency array means this effect runs only once after the initial render

 const dispatch = useDispatch();
  

  const history = useHistory();
  useEffect(() => {
     
    if(data?.token){
          
     history.push('/login');
   
   } })
 const [loader , setLoader] =useState({status:false});

 

/* Handle Signup Function */
const handleVerifyOTP=(e)=>{
  e.preventDefault();
//console.log(signup)
//setMyOTPData({user_email:data?.user_email,OTP:inputs.join('')})
 
setLoader({status:true});
  const user = dispatch(userVerifyOTP({user_email:data?.user_email,OTP:inputs.join('')}));
  /* get response as Promise   */
  user.then(response => {
  
    if(response){
     console.log(response)
      if(response?.user_email){
       
         history.push('/');

      }
      else
      {
     //   history.push('/verificationFailed');
     
      }
     

    }else{


    }
    ;
   


setLoader({status:false});


//history.push('/dashboard/profile');


  }).catch(error => {
   
setLoader({status:false});
    console.error(error);
  });
 
  }

    return <>
    
{<>

{<Loading  Load={loader?.status}/>}
  <form onSubmit={handleVerifyOTP} >
  <div  className="ikcraft_login-signup-backgropj"><div  className="ikcraft_login-signup-card"><div  className="blank"> </div>
  <div  className="ikcraft_login-signup-card-outerj"><div  className="ikcraft_login-signup-inner">
  <div  className="ikcraft_blankRight ikcraft_login-signup-right-signup">
      <div></div>
      <div><Link  style={{ float:'left'
    ,padding:'10px 25px',
  textDecoration: 'none',
  position: 'relative',
  top: '2px',
  fontSize: '65px',textAlign:'center',
  border: '0px',
  fontWeight: 'bold',
  background: 'linear-gradient(270deg, #E02CD3 20.56%, #6243EB 56.63%, #0952FF 69.98%)',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
}}  to="">
               
                <span >ClassMock</span>
                </Link> </div>   <div>  </div>
    </div>  <div  className="ikcraft_login-signup-left-signup ">
      <h1 style={{"textAlign":"center"}}> Validate OTP </h1>
      
 <div  className="ikcraft_login-input-card-otp">
     {inputs.map((value, index) => (
        <input className="ikcraft_input-textbox-otp" required
          key={index}
          ref={inputRefs.current[index]}
          type="number"
          maxLength="1"
          value={value}
          onChange={(e) => handleChange(index, e.target.value)}
        />
      ))}
    </div>  
	  
   
   
    
   
     
   
	
	<div  className="ikcraft_login-input-card">
   
  <button  className="ikcraft_login-signup-button" type="submit" id="signupBtn">Click To Verify OTP</button>
      
  </div>

  <div> 
    
    
    
    
  </div>
 </div>
    
    
  </div></div><div></div></div></div>
   </form>
</>}
    </>

}
export default ValidateOTP;